import { styled } from "@health-zelas/delta"

export const Wrapper = styled('div', {
  maxWidth: '47rem',
  paddingBottom: '$md'
})

export const ButtonGroup = styled('div', {
  display: 'flex',
  flexDirection: 'column-reverse',
  gap: '$xxxs',
  marginTop: '$md',

  '@sm': {
    marginTop: '$lg',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  }
})
